export const IDLE = 'IDLE';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';
export const LOADING = 'LOADING';
